export default "__VITE_ASSET__Prc2FG6H__"